import { Component, OnInit } from '@angular/core';
import { NgForm }            from '@angular/forms';
import { TranslateService }  from '@ngx-translate/core';
import { UIRouter }          from '@uirouter/angularjs';

import { CompanyService }     from '../companies/company.service';
import { MailchimpListModel } from './typings/mailchimp.list';
import { MailchimpService }   from './mailchimp.service';
import { MessagesService }    from '../messages/messages.service';
import { SessionService }     from '../sessions/session.service';

@Component({
  selector   : 'mailchimp-settings',
  template: require('./mailchimp.settings.component.html')
})
export class MailchimpSettingsComponent implements OnInit {
  lists         : Array<MailchimpListModel> = [];
  isBeta        : boolean;
  selectedListId: string;

  title = this.mailchimpService.title;

  constructor (
    public  companyService  : CompanyService,
    private mailchimpService: MailchimpService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.isBeta = window.location.host.indexOf('beta') >= 0
      && !this.sessionService.base().demo_user
      && !this.companyService.country('unitedKingdom');

    if ( this.companyService.hasIntegration('mailchimp') ) {
      this.mailchimpService.getLists()
      .then(( lists : Array<MailchimpListModel> ) => this.lists = lists)
      .catch(error => this.messagesService.error(error));
    }
  }

  authorize () : void {
    this.mailchimpService.authorize();
  }

  sync ( form : NgForm ) : void {
    this.mailchimpService.sync(this.selectedListId)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MAILCHIMP.SYNC_MESSAGE'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  unauthorize () : void {
    this.mailchimpService.unauthorize()
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.MAILCHIMP.MAILCHIMP_UNAUTHORISED'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
